import ApiService from '../services/apiService';

export const indexFeePayrollsRequest = ({
  dispatch,
  params = {},
  failureCallback,
  successCallback,
  callback,
  service = 'payroll'
}) => {
  ApiService.request('get', '/fee_payrolls', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback,
    service
  });
};

export const feePayrollMassiveExportRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/fee_payrolls/massive_export`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePayrollMassiveDestroyRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('delete', `/fee_payrolls/massive_destroy`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePayrollReloadRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('put', `/fee_payrolls/${id}/reload`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePayrollExportRequest = ({ dispatch, params = {}, successCallback, callback, service = 'payroll' }) =>
  ApiService.request('get', `/fee_payrolls/export`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePayrollDestroyRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('delete', `/fee_payrolls/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePayrollEmployeesRequest = ({ dispatch, params = {}, successCallback, callback, service = 'payroll' }) =>
  ApiService.request('get', `/fee_payrolls/employees`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const downloadFeePayrollDocumentsRequest = ({
  dispatch,
  params = {},
  format,
  responseType,
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', '/fee_payrolls/download.zip', {
    dispatch,
    params,
    format,
    responseType,
    successCallback,
    callback,
    service
  });

export const sendFeePayrollStatementRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', '/fee_payrolls/send_email', {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const createFeePayrollWorkflowRequest = ({
  dispatch,
  params = {},
  successCallback,
  failureCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', '/fee_payrolls/create_workflow', {
    dispatch,
    params,
    successCallback,
    failureCallback,
    callback,
    service
  });
